import { PRODUCTION } from '@/constants';
import Image, { StaticImageData } from 'next/image';
import { AdsPlaceholder } from './ads-placeholder/ads-placeholder';
import styles from './ads.module.css';
import GoogleAd from './google-ads';

export type Props = {
  size?: 'md' | 'lg' | 'xlg';
  img?: string | StaticImageData;
  alt?: string;
  googleAdFormat?: string;
  fullWidthResponsive?: boolean;
  unoptimized?: boolean;
};

export function Ads({
  size = 'md',
  img,
  alt = 'Publicidade',
  fullWidthResponsive = true,
  googleAdFormat = 'auto',
  unoptimized = false,
}: Props) {
  if (PRODUCTION) {
    return img ? (
      <div className={styles.ads + ' ' + styles[size]}>
        <Image
          src={img}
          alt={alt}
          fill
          style={{
            objectFit: 'contain',
          }}
          preload={false}
          // `.ads` tem width:100% e max-width:1200px, entao o navegador escolhe
          // pela largura da viewport ate 1200 e trava ali. O valor fixo anterior
          // pedia 1200px de largura tambem num celular de 360.
          sizes="(max-width: 1200px) 100vw, 1200px"
          // Estava `unoptimized` literal, ou seja, sempre true: a prop acima era
          // declarada e nunca lida, e toda imagem que passa por aqui ia crua.
          // Segue true onde o chamador pede — o WebP animado do banner do canal
          // perde a animacao se for otimizado.
          unoptimized={unoptimized}
        />
      </div>
    ) : (
      <GoogleAd
        fullWidthResponsive={fullWidthResponsive}
        format={googleAdFormat}
        slot="5993932940"
        googleAdId="ca-pub-9646893046773308"
      />
    );
  }
  return (
    <div className={styles.ads + ' ' + styles[size]} style={{ position: 'relative' }}>
      {img ? (
        <Image src={img} alt={alt} fill style={{ objectFit: 'contain' }} unoptimized={unoptimized} />
      ) : (
        <AdsPlaceholder />
      )}
    </div>
  );
}
